// These variables should only be manipulated by the ci/cd pipeline.
export const compat_tsg_ids: string | undefined  = '';
export const dev_environment = 'dev';

export const deprecated_tsg_ids = '1320447254,1807272674';

